import {Component, Input} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {CommonModule} from '@angular/common';

@Component({
  selector: 'app-modal',
  standalone: true,
  imports: [
    TranslateModule,
    CommonModule
  ],
  templateUrl: './modal.component.html',
  styleUrl: './modal.component.scss'
})
export class ModalComponent {

  @Input() title?: string | undefined = '';
  @Input() open: boolean = false;
  @Input() closeOnClickOutside: boolean = false;

  public openDialog(): void {
    this.open = true;
  }

  public closeDialog(): void {
    this.open = false;
  }
}
